import PropTypes from 'prop-types'

export const dailyGreetingShellPropTypes = {
  userName: PropTypes.string,
  meetingsLinkTo: PropTypes.string,
  tasksLinkTo: PropTypes.string,
  overdueStartDate: PropTypes.string,
  tasksLinkMode: PropTypes.oneOf(['route', 'overlay']).isRequired
}

export const dailyGreetingRedtailOuterPropTypes = {
  ...dailyGreetingShellPropTypes,
  blueprintCode: PropTypes.string,
  meetingsPresentationKey: PropTypes.string,
  tasksPresentationKey: PropTypes.string
}

export const dailyGreetingRedtailStandardPropTypes = {
  userName: PropTypes.string,
  meetingsLinkTo: PropTypes.string,
  tasksLinkTo: PropTypes.string,
  overdueStartDate: PropTypes.string,
  tasksLinkMode: PropTypes.oneOf(['route', 'overlay']).isRequired,
  blueprintCode: PropTypes.string,
  tasksPresentationKey: PropTypes.string,
  blueprint: PropTypes.object,
  isLoadingBlueprint: PropTypes.bool
}

export const dailyGreetingRedtailWithBlueprintMeetingsPropTypes = {
  userName: PropTypes.string,
  meetingsLinkTo: PropTypes.string,
  tasksLinkTo: PropTypes.string,
  overdueStartDate: PropTypes.string,
  tasksLinkMode: PropTypes.oneOf(['route', 'overlay']).isRequired,
  blueprintCode: PropTypes.string,
  meetingsPresentationKey: PropTypes.string,
  tasksPresentationKey: PropTypes.string,
  blueprint: PropTypes.object,
  isLoadingBlueprint: PropTypes.bool,
  meetingsSlot: PropTypes.shape({
    config: PropTypes.object
  })
}
